import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { Note } from '../../../core/data';
import { markAsTouched } from '../../utils';
import { requiredValidator } from '../../validators';

@Component({
  selector: 'app-note-update-modal',
  templateUrl: './note-update-modal.component.html',
})
export class NoteUpdateModalComponent {
  active = false;
  form = new FormGroup({
    id: new FormControl(),
    contents: new FormControl(null, requiredValidator()),
    visible: new FormControl(),
  });
  @Input() showVisibility = false;
  @Output() onChange = new EventEmitter<Note>();

  open(note?: Note) {
    if (note) {
      this.form.patchValue(note);
    }

    this.active = true;
  }

  close() {
    this.form.reset();
    this.active = false;
  }

  submit() {
    if (this.form.valid) {
      this.onChange.emit(this.form.value);
    } else {
      markAsTouched(this.form);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/notes/note-update-modal.component.ts